
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as api from "@/lib/api";
import { queryKeys } from "@/lib/query-keys";
import type {
  ReviewSubmissionRequest,
  SubmitQuestionRequest,
} from "@/lib/types";

export function useMySubmissions() {
  return useQuery({
    queryKey: queryKeys.submissions.mine(),
    queryFn: api.getMySubmissions,
  });
}

export function useAdminSubmissions() {
  return useQuery({
    queryKey: queryKeys.submissions.admin(),
    queryFn: api.getAdminSubmissions,
  });
}

export function useCreateSubmission(examSlug: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: SubmitQuestionRequest) =>
      api.createSubmission(examSlug, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.submissions.mine() });
    },
  });
}

export function useReviewSubmission() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      data,
    }: {
      id: string;
      data: ReviewSubmissionRequest;
    }) => api.reviewSubmission(id, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.submissions.admin() });
    },
  });
}
